// ═══════════════════════════════════════════════════════════
// Session persistence — user identity only
// Tokens live in HttpOnly cookies managed server-side.
// Only non-sensitive user identity is cached in localStorage.
// ═══════════════════════════════════════════════════════════

import type { V2User } from '../api/types';

const USER_KEY = 'ogemc_user';

export function saveUser(user: V2User): void {
  try { localStorage.setItem(USER_KEY, JSON.stringify(user)); } catch {}
}

export function loadUser(): V2User | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? (JSON.parse(raw) as V2User) : null;
  } catch { return null; }
}

export function clearUser(): void {
  try { localStorage.removeItem(USER_KEY); } catch {}
}
